import { gql } from "@apollo/client"

export const DeleteUser = gql`
mutation DeleteUser($deleteUserId: ID!) {
  deleteUser(id: $deleteUserId) {
    status
  }
}
`